import React, { useEffect, useState } from 'react'
import {
  AccidentInputDataType,
  AccidentOutputDataType,
} from '../components/forms/AccidentForm'
import AccidentForm from '../components/forms/AccidentForm'
import { useClaimant } from '../context/col'
import useAsync from '../hooks/useAsync'
import useGetData from '../hooks/useGetData'
import {
  CaseReportParamsType,
  CaseReportRespType,
  transformCaseReportRespToCaseReportParams,
} from '../models'
import { putCaseReport } from '../services/case-report/put'

export type AccidentPageProps = {
  transitions: AccidentPageTransitions
}

export type AccidentPageTransitions = {
  goBack: () => void
  goToNextPage: () => void
}

const Accident = (props: AccidentPageProps) => {
  const { state, dispatch } = useClaimant()
  const [ifEqual, setIfEqual] = useState<boolean>(true)

  useEffect(() => {
    dispatch({ type: 'control_change', payload: { controlChange: ifEqual } })
  }, [ifEqual])

  const { fetch: fetchData, pending: loading } = useGetData({})

  useEffect(() => {
    fetchData()
  }, [])

  const handleAccidentPageBack = () => {
    props.transitions.goBack()
  }

  const handleAccidentPageSubmitted = (value: AccidentOutputDataType) => {
    if (state.loadedCaseReportResp == null) {
      throw new Error('Illegal state -- no loadedCaseReportResp')
    }
    const origCaseReportResp: CaseReportRespType = state.loadedCaseReportResp
    const newCaseReportDataResp: CaseReportRespType = {
      ...origCaseReportResp,
      casePA: value.casePA,
      caseCommon: value.caseCommon,
    }

    const caseReportParamsForUpdate: CaseReportParamsType =
      transformCaseReportRespToCaseReportParams(newCaseReportDataResp)

    dispatch({
      type: 'update_caseReportParams',
      payload: { data: newCaseReportDataResp, page: 4 },
    })

    doPutCaseReport({
      caseReportId: state.caseReportId,
      caseReportParams: caseReportParamsForUpdate,
    })
  }

  function handleAccidentPageDataChanged(isChanged: boolean): void {
    setIfEqual(isChanged)
  }

  const { fetch: doPutCaseReport, pending } = useAsync({
    promiseFn: (params: any) => putCaseReport(params),
    onData: () => {
      dispatch({ type: 'control_change', payload: { controlChange: true } })
      //history.push(pathToBankAccount)
      props.transitions.goToNextPage()
    },
    onError: (error) => {
      dispatch({ type: 'error', payload: { error: error.message } })
    },
  })

  const accidentFormData: AccidentInputDataType = {
    casePA: state.loadedCaseReportResp?.casePA ?? null,
    caseCommon: state.loadedCaseReportResp?.caseCommon ?? null,
  }

  return (
    <AccidentForm
      caseReportId={state.caseReportId!}
      data={accidentFormData}
      isPageConfirmInProgress={pending}
      errorMessage={state.error}
      onPageContinue={handleAccidentPageSubmitted}
      onPageBack={handleAccidentPageBack}
      notifyDataChanged={handleAccidentPageDataChanged}
    />
  )
}

export default Accident
